window.actualizarModalReporteInyeccion = null;

if (window.location.pathname === "/inyeccion/periodo" || window.location.pathname === "/zona-trabajo") {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    // ─── Helpers de formato ──────────────────────────────────────────────────────
    const num          = n => (Number(n) || 0).toLocaleString('en-US');
    const numInput     = n => (Number(n) || "") === "" ? "" : (Number(n)).toLocaleString('en-US');
    const numberFormat = n => (n === null || n === "" || isNaN(n)) ? "-" : new Intl.NumberFormat('en-US').format(n);
    const numberDecimal= n => (n === null || n === "" || isNaN(n)) ? "-" : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
    const fecha        = f => f.split('-').reverse().join('/');
    const txt          = t => String(t ?? '').trim();
    const formatText   = s => (!s || s.trim() === "") ? "-" : String(s);
    const hora         = h24 => { let [h, m] = h24.split(':'); return `${h % 12 || 12}:${m} ${h < 12 ? 'a.m.' : 'p.m.'}`; };

    // ─── Helper: set value o textContent según tipo de elemento ─────────────────
    const set = (id, value) => {
        const el = document.querySelector(`#modalProduccionInyeccion #${id}`);
        if (!el) return;
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') el.value = value;
        else el.textContent = value;
    };

    // ─── Helper: mostrar u ocultar con display ───────────────────────────────────
    const mostrar  = id => { const el = document.getElementById(id); if (el) el.style.display = ''; };
    const ocultar  = id => { const el = document.getElementById(id); if (el) el.style.display = 'none'; };
    const mostrarEl= el => { if (el) el.style.display = ''; };
    const ocultarEl= el => { if (el) el.style.display = 'none'; };

    // ─── Helper: filas vacías ────────────────────────────────────────────────────
    const filaSinDatos = (colspan, texto) => `
        <tr class="no-data">
            <td colspan="${colspan}">
                <div class="cont-no-data">
                    <img class="icono-pequeño-gris" src="/public/build/img/icons/informacion.svg" alt="">
                    ${texto}
                </div>
            </td>
        </tr>`;

    // ─── Renderizar tbody de lotes ────────────────────────────────────────────────
    const renderLotes = (tbodyId, lotes, clasesTr, dataModal, descripcionMaterial) => {
        const tbody = document.getElementById(tbodyId);
        if (!tbody) return;
        if (lotes.length === 0) {
            tbody.innerHTML = filaSinDatos(4, 'No hay registros de lotes.');
            return;
        }
        tbody.innerHTML = lotes.map((lote, idx) => `
            <tr data-modal="${dataModal}"
                data-id="${lote.idLineaLoteMateriaPrima}"
                data-id-materia-prima="${lote.idMateriaPrima}"
                data-material="${descripcionMaterial}"
                class="trSelect ${clasesTr} btnModal">
                <td>${idx + 1}</td>
                <td>${lote.numeroLote}</td>
                <td>${hora(lote.horaInicio)}</td>
                <td>${hora(lote.horaFin)}</td>
            </tr>`).join('');
    };

    // ─── Función principal ────────────────────────────────────────────────────────
    window.actualizarModalReporteInyeccion = (id) => {
        const modal = document.querySelector("#modalProduccionInyeccion");
        const pestañaActiva = modal.querySelector(".etiquetaSelect");
        const idEtiquetaGuardada = pestañaActiva ? pestañaActiva.getAttribute("data-etiqueda") : "cabecera";

        const url = `/api/inyeccion/infoReporte?IdReporteInyeccion=${id}`;

        fetch(url, requestOptions)
            .then(response => {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(result => {
                const data = result.result;
                const { infoUsuario, encabezado, materiaPrima, lotesMtPrima1, lotesMtPrima2, lotesMolino, produccionInyeccion, pncInyeccion, tiempoMuerto, entrega } = data;
                const rolUsuario = infoUsuario.idRol;
                const estado = encabezado.estado;
                const hayRegistros = produccionInyeccion.length > 0 || pncInyeccion.length > 0
                    || tiempoMuerto.length > 0 || lotesMtPrima1.length > 0
                    || lotesMtPrima2.length > 0 || lotesMolino.length > 0;

                // ── Título ───────────────────────────────────────────────────────
                set('tituloModalInyeccion',
                    `ID ${encabezado.idReporteInyeccion} · Reporte de producción inyección · ${fecha(encabezado.fechaCreacionTurnoInyeccion)}`
                );

                // ── Hidden inputs ────────────────────────────────────────────────
                set('idReporteInyeccion', encabezado.idReporteInyeccion);

                // ── Botones de acción (mostrar según estado y rol) ───────────────
                const btnFinalizar  = document.getElementById('btnModalFinalizarReporteInyeccion');
                const btnEliminar   = document.getElementById('btnEliminarReporteInyeccion');
                const btnReactivar  = document.getElementById('btnReactivarReporteInyeccion');

                ocultarEl(btnFinalizar);
                ocultarEl(btnEliminar);
                ocultarEl(btnReactivar);

                if (estado == 1) {
                    mostrarEl(btnFinalizar);
                }
                if (estado == 1 && rolUsuario == 1) {
                    btnEliminar.setAttribute('data-id', encabezado.idReporteInyeccion);
                    btnEliminar.setAttribute('data-tiene-registros', hayRegistros ? '1' : '0');
                    mostrarEl(btnEliminar);
                }
                if (estado == 2 && rolUsuario == 1) {
                    btnReactivar.setAttribute('data-id', encabezado.idReporteInyeccion);
                    mostrarEl(btnReactivar);
                }

                // ── Cabecera: imágenes y nombres ─────────────────────────────────
                const imgMecanico = document.getElementById('fotoMecanico');
                const imgOperario = document.getElementById('fotoOperario');
                if (imgMecanico) imgMecanico.src = `/public/uploads/usuarios/${encabezado.fotoMecanico}?v=${Date.now()}`;
                if (imgOperario) imgOperario.src = `/public/uploads/usuarios/${encabezado.fotoOperario}?v=${Date.now()}`;

                set('nombreMecanico', encabezado.nombreMecanico);
                set('nombreOperario', encabezado.nombreOperario);

                // ── Cabecera: inputs de info ─────────────────────────────────────
                set('fechaCreacionTurnoInyeccion', encabezado.fechaCreacionTurnoInyeccion);
                set('idZona',        encabezado.zonasTrabajo);
                set('idTurno',       encabezado.nombreTurno);
                set('idMaquina',     encabezado.nombreMaquina);
                set('numOf',         encabezado.nombreMaquina);
                set('idReferencia',  encabezado.codigoSap);
                set('descReferencia',encabezado.DescripSap);
                set('ciclo',         encabezado.cicloSegundos);
                set('cavMolde',      encabezado.cavMolde);
                set('cavActivas',    encabezado.cavActivas);
                set('undHora',       numberFormat(encabezado.undHora));

                // ── Composición producto: canvaBloqueado ─────────────────────────
                const contLotes = document.getElementById('contLotesCompProducto');
                if (contLotes) {
                    contLotes.classList.toggle('canvaBloqueado', estado != 1);
                }

                // ── Materia prima 1 ──────────────────────────────────────────────
                if (materiaPrima.idMtPrima1 != 0) {
                    mostrar('seccionMateriaPrima1');
                    set('idMateriaPrima1',         materiaPrima.idMtPrima1);
                    set('codigoMateriaPrima1',     materiaPrima.codigoMateriaPrima1);
                    set('descripcionMateriaPrima1',materiaPrima.descripcionMateriaPrima1);
                    set('proveedorMateriaPrima1',   materiaPrima.proveedorMateriaPrima1);
                    set('porMateriaPrima1',         num(materiaPrima.porMtPrima1));
                    estado == 1 ? mostrar('btnModalAgregarLoteMateriaPrimaInyeccion')
                                : ocultar('btnModalAgregarLoteMateriaPrimaInyeccion');
                    renderLotes('tbodyLotesMtPrima1', lotesMtPrima1,
                        'trSelectLoteMateriaPrimaInyeccion', 'modalEditarLoteMateriaPrimaInyeccion',
                        materiaPrima.descripcionMateriaPrima1);
                } else {
                    ocultar('seccionMateriaPrima1');
                }

                // ── Materia prima 2 ──────────────────────────────────────────────
                if (materiaPrima.idMtPrima2 != 0) {
                    mostrar('seccionMateriaPrima2');
                    set('idMateriaPrima2',         materiaPrima.idMtPrima2);
                    set('codigoMateriaPrima2',     materiaPrima.codigoMateriaPrima2);
                    set('descripcionMateriaPrima2',materiaPrima.descripcionMateriaPrima2);
                    set('proveedorMateriaPrima2',   materiaPrima.proveedorMateriaPrima2);
                    set('porMateriaPrima2',         num(materiaPrima.porMtPrima2));
                    estado == 1 ? mostrar('btnModalAgregarLoteMateriaPrima2Inyeccion')
                                : ocultar('btnModalAgregarLoteMateriaPrima2Inyeccion');
                    renderLotes('tbodyLotesMtPrima2', lotesMtPrima2,
                        'trSelectLoteMateriaPrimaInyeccion', 'modalEditarLoteMateriaPrimaInyeccion',
                        materiaPrima.descripcionMateriaPrima2);
                } else {
                    ocultar('seccionMateriaPrima2');
                }

                // ── Molido ───────────────────────────────────────────────────────
                if (materiaPrima.idMtMolino != 0) {
                    mostrar('seccionMolino');
                    set('idMolino',         materiaPrima.idMtMolino);
                    set('codigoMolino',     materiaPrima.codigoMolido);
                    set('descripcionMolino',materiaPrima.descripcionMolido);
                    set('proveedorMolino',  materiaPrima.proveedorMolido);
                    set('porMolino',        num(materiaPrima.porMtMolino));
                    estado == 1 ? mostrar('btnModalAgregarLotesMolinoInyeccion')
                                : ocultar('btnModalAgregarLotesMolinoInyeccion');
                    renderLotes('tbodyLotesMolino', lotesMolino,
                        'trSelectLotesMolinoInyeccion', 'modalEditarLotesMolinoInyeccion',
                        materiaPrima.descripcionMolido);
                } else {
                    ocultar('seccionMolino');
                }

                // ── Reporte producción ───────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarProduccionInyeccion')
                            : ocultar('btnAgregarProduccionInyeccion');

                const tbodyProduccion = document.getElementById('tbodyProduccionInyeccion');
                if (tbodyProduccion) {
                    tbodyProduccion.innerHTML = produccionInyeccion.length === 0
                        ? filaSinDatos(4, 'No hay registros de producción para este turno.')
                        : produccionInyeccion.map(p => `
                            <tr data-modal="modalEditarProduccionInyeccion"
                                data-id="${p.idLineaProduccionInyeccion}"
                                class="trSelect trSelectProduccionInyeccion btnModal">
                                <td>${hora(p.horaInicio)}</td>
                                <td>${hora(p.horaFin)}</td>
                                <td>${numberFormat(p.tiempoProductivo)}</td>
                                <td>${numberFormat(p.undsBuenas)}</td>
                            </tr>`).join('');
                }

                // ── Tiempos muertos ──────────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarTiempoMuerto')
                            : ocultar('btnAgregarTiempoMuerto');

                const tbodyTiempo = document.getElementById('tbodyTiempoMuerto');
                if (tbodyTiempo) {
                    tbodyTiempo.innerHTML = tiempoMuerto.length === 0
                        ? filaSinDatos(4, 'No hay registros de tiempo muerto para este turno.')
                        : tiempoMuerto.map(t => `
                            <tr data-modal="modalEditarTiempoMuerto"
                                data-id="${t.idLineaTiempoMuerto}"
                                class="trSelect trSelectTiempoMuerto btnModal">
                                <td>${hora(t.horaInicio)}</td>
                                <td>${hora(t.horaFin)}</td>
                                <td>${numberFormat(t.minTiempoMuerto)}</td>
                                <td>${formatText(t.nombreCausaTiempoMuerto)}</td>
                            </tr>`).join('');
                }

                // ── Producto no conforme ─────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarPncInyeccion')
                            : ocultar('btnAgregarPncInyeccion');

                const tbodyPnc = document.getElementById('tbodyPncInyeccion');
                if (tbodyPnc) {
                    tbodyPnc.innerHTML = pncInyeccion.length === 0
                        ? filaSinDatos(9, 'No hay registros de producto no conforme para este turno.')
                        : pncInyeccion.map(p => `
                            <tr data-modal="modalEditarPncInyeccion"
                                data-id="${p.idLineaPncInyeccion}"
                                class="trSelect trSelectPncInyeccion btnModal">
                                <td>${hora(p.horaInicio)}</td>
                                <td>${hora(p.horaFin)}</td>
                                <td>${formatText(p.nombreDefectoPreforma)}</td>
                                <td>${numberFormat(p.undsDefectuosas)}</td>
                                <td>${formatText(p.nombreContaminacion)}</td>
                                <td>${numberFormat(p.undsContaminadas)}</td>
                                <td>${numberFormat(p.undsCalidad)}</td>
                                <td>${numberDecimal(p.grTorta)}</td>
                                <td>${formatText(p.observaciones)}</td>
                            </tr>`).join('');
                }

                // ── Observaciones ────────────────────────────────────────────────
                set('observacionesInyeccion', txt(encabezado.observaciones));
                const contObs = document.getElementById('contObservaciones');
                if (contObs) contObs.classList.toggle('canvaBloqueado', estado != 1);

                // ── Entrega ──────────────────────────────────────────────────────
                const contEntrega = document.getElementById('contEntrega');
                if (contEntrega) contEntrega.classList.toggle('canvaBloqueado', estado != 1);

                set('producidoTotalHeader', `${num(entrega.producido)} und`);
                set('unidadEmpaqueHeader', `${num(encabezado.unidadEmpaque)} und`);
                set('producidoTotal',  `${num(entrega.producido)} und`);
                set('entregadoTotal',  `${num(entrega.entregado)} und`);
                set('pendienteTotal',  `${num(entrega.pendiente)} und`);
                const unidadEmpaqueCanasta = Number(entrega.unidadEmpaqueCanasta) || 456;
                const unidadEmpaqueBolsa = Number(entrega.unidadEmpaqueBolsa) || 504;
                const canvaEntrega = document.getElementById('canvaEntrega');
                if (canvaEntrega) {
                    canvaEntrega.setAttribute('data-unidad-empaque-canasta', unidadEmpaqueCanasta);
                    canvaEntrega.setAttribute('data-unidad-empaque-bolsa', unidadEmpaqueBolsa);
                }
                set('unidadEmpaqueCanastaInyeccion', num(unidadEmpaqueCanasta));
                set('unidadEmpaqueBolsaInyeccion', num(unidadEmpaqueBolsa));
                set('canastas',   numInput(entrega.numCanastas));
                set('canastasUnd',`${num(entrega.undsCanasta)} und`);
                set('bolsas',     numInput(entrega.numBolsas));
                set('bolsasUnd',  `${num(entrega.undsBolsa)} und`);
                set('retenido',   numInput(entrega.retenido));
                set('rechazado',  numInput(entrega.rechazado));

                // ── Botón guardar ────────────────────────────────────────────────
                estado == 1 ? mostrar('contBtnGuardarInyeccion')
                            : ocultar('contBtnGuardarInyeccion');

                // ── Restaurar pestaña activa ─────────────────────────────────────
                // Limpiar selección anterior
                modal.querySelectorAll('[data-etiqueda]').forEach(btn => btn.classList.remove('etiquetaSelect'));
                modal.querySelectorAll('.canvaMultiEtiqueta > [id^="canva"]').forEach(c => c.classList.add('oculto'));

                const btnParaActivar = modal.querySelector(`[data-etiqueda="${idEtiquetaGuardada}"]`);
                if (btnParaActivar) {
                    btnParaActivar.classList.add('etiquetaSelect');
                    const idCanva = 'canva' + idEtiquetaGuardada.charAt(0).toUpperCase() + idEtiquetaGuardada.slice(1);
                    const seccionActiva = modal.querySelector('#' + idCanva);
                    if (seccionActiva) seccionActiva.classList.remove('oculto');
                } else {
                    modal.querySelector('#canvaCabecera').classList.remove('oculto');
                    modal.querySelector('[data-etiqueda="cabecera"]').classList.add('etiquetaSelect');
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrio un error en ver reporte inyección.");
            });
    };


    // ─── Listener: abrir modal ────────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.btnVerReporte');
        if (target && target.getAttribute('data-modal') === 'modalProduccionInyeccion') {
            const idReporte = target.getAttribute('data-id');
            const modalElemento = document.querySelector("#modalProduccionInyeccion");
            if (idReporte && modalElemento && typeof window.actualizarModalReporteInyeccion === 'function') {
                window.actualizarModalReporteInyeccion(idReporte);
            }
        }
    });

    // ─── Listener: reactivar reporte ─────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('#btnReactivarReporteInyeccion');
        if (!target) return;

        const idReporte = target.getAttribute('data-id');
        if (!idReporte) return;
        if (!confirm('¿Deseas reactivar este reporte de turno?')) return;

        target.disabled = true;
        const spinner = target.querySelector('.spinner');
        if (spinner) spinner.classList.add('spinner--active');

        fetch('/api/inyeccion/reactivar-reporte', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `idEncabezadoReporteInyeccion=${idReporte}`
        })
        .then(res => res.json())
        .then(result => {
            if (result.result.hayErrores) {
                alert(result.result.errores[0].mensaje ?? 'Error al reactivar el reporte.');
                return;
            }
            window.actualizarModalReporteInyeccion(idReporte);
            const params = new URLSearchParams(window.location.search);
            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(params.get('mes'), params.get('año'));
            }
        })
        .catch(() => alert('Error al conectar con el servidor.'))
        .finally(() => {
            target.disabled = false;
            if (spinner) spinner.classList.remove('spinner--active');
        });
    });

    // ─── Listener: eliminar reporte ──────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('#btnEliminarReporteInyeccion');
        if (!target) return;

        const idReporte = target.getAttribute('data-id');
        const tieneRegistros = target.getAttribute('data-tiene-registros') === '1';

        if (tieneRegistros) {
            alert('No se puede eliminar el reporte porque tiene registros asociados (producción, PNC, tiempos muertos o lotes).');
            return;
        }
        if (!confirm('¿Estás seguro de que deseas eliminar este reporte? Esta acción no se puede deshacer.')) return;

        target.disabled = true;
        const spinner = target.querySelector('.spinner');
        if (spinner) spinner.classList.add('spinner--active');

        fetch('/api/inyeccion/eliminar-reporte', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `idEncabezadoReporteInyeccion=${idReporte}`
        })
        .then(res => res.json())
        .then(result => {
            if (result.result.hayErrores) {
                alert(result.result.errores[0].mensaje ?? 'Error al eliminar el reporte.');
                return;
            }
            const modal = document.querySelector('#modalProduccionInyeccion');
            if (modal) {
                modal.querySelectorAll('form').forEach(f => f.reset());
                modal.classList.remove('modal--show');
            }
            const params = new URLSearchParams(window.location.search);
            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(params.get('mes'), params.get('año'));
            }
        })
        .catch(() => alert('Error al conectar con el servidor.'))
        .finally(() => {
            target.disabled = false;
            if (spinner) spinner.classList.remove('spinner--active');
        });
    });
}
